<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :span="12">
              <label class="title">工作量统计</label>
              <a-range-picker @change="onChange" />
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- table区域-begin -->
      <div>
        <a-table
          ref="table"

          size="middle"
          rowKey="resultid"
          :columns="columns"
          :dataSource="dataSource"
          :scroll="{x:`${width}`,y:'calc(100vh - 350px)'}"
          :pagination="false"
          :loading="loading"
          @change="handleTableChange">
          <span slot="baselineRepRate">
            基线应答率
            <a-tooltip class="info-row" >
              <template slot="title">
                基线应答率=基线提交人数/注册人数-筛选期的人数-终止筛选的人数中（符合排除，不符合纳入，去重后的人数）
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </span>
          <span slot="periodNum">
            随访完成量
            <a-tooltip class="info-row" >
              <template slot="title">
                动态随访完成量：本月该调查员提交的随访人数/本月系统随机分配给该调查员的随访人数（%）
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </span>
        </a-table>
      </div>
    </a-card>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import { getAction,postAction} from '@/api/manage'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'Workload',
    mixins: [JeecgListMixin],
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        centerName:'',
        columns: [],
        url: {
          list: "/project/statistic/workload",
        },
        width:100,
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      this.queryParam.projectId = this.projectId
      this.loadColumn()
      this.loadData()
    },
    watch:{
    },
    methods:{
      onChange(date, dateString){
        this.queryParam.startDate=dateString[0]
        this.queryParam.endDate=dateString[1]
        this.loadData()
      },
      async loadColumn(){
        // 添加 周期的column
        const columns = [
          {
            title: '调查员',
            align:"center",
            width: 100,
            dataIndex: 'personName'
          },
          {
            title: '注册人数',
            width: 100,
            align:"center",
            dataIndex: 'registerNum'
          },
          {
            title: '基线提交人数',
            align:"center",
            width: 100,
            dataIndex: 'baselineSubmitNum'
          },
          {
            title: '基线终止随访人数',
            align:"center",
            width: 100,
            dataIndex: 'baselineEndNum'
          },
          {
            // title: '基线应答率统计',
            slots: { title: 'baselineRepRate' },
            align:"center",
            width: 100,
            dataIndex: 'baselineRepRate'
          }
        ]


        let workloadConfigData = []
        // 添加 配置的元素column
        await getAction('/project/projectStatisticWorkloadConfig/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            workloadConfigData = res.result
          }
        })
        workloadConfigData.forEach(workloadConfig=>{
          columns.push({
            title: workloadConfig.periodItemName+'_'+(workloadConfig.formItemName || workloadConfig.formName)+' 完成人数',
            width: 100,
            align:"center",
            dataIndex: `${workloadConfig.periodItemId}_${workloadConfig.formItemId || workloadConfig.formId}`
          })
        })
        // 添加 周期column
        let periodItemData = []
        await getAction('/project/projectPeriodItem/list',{projectId:this.projectId,base:'0'}).then(res=>{
          if(res.success){
            periodItemData = res.result
          }
        })
        periodItemData.forEach(periodItem=>{
          columns.push({
            title: periodItem.name +' 完成人数',
            width: 100,
            align:"center",
            dataIndex: periodItem.id
          })
        })


        columns.push({
          title: '随访数量总计',
          width: 100,
          align:"center",
          dataIndex: 'periodSum'
        })
        columns.push({
          title: '随访终止随访人数',
          width: 100,
          align:"center",
          dataIndex: 'periodEndNum'
        })
        columns.push({
          // title: '随访完成量',
          align:"center",
          width: 100,
          slots: { title: 'periodNum' },
          dataIndex: 'periodNum'
        })
        this.width = 800 + periodItemData.length*100 + workloadConfigData.length*100

        this.columns = columns
      }
    }
  }
</script>

<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>